abstract class RadioButton extends SelectableWidget{
    radioGroup: RadioGroup;
    selected: boolean;

    protected constructor(identifier: string, label: string, controller: Controller, container: JQuery, radioGroup: RadioGroup, mode: string) {
        super(identifier, Action.SELECTED, controller, container, mode);

        this.radioGroup = radioGroup;
        this.selected = false;

        this.initHTML(container, label);
        this.initHelpButton();
        this.initAcknowledgements();
        this.initBehavior();
    }

    /**
     * Replace the HTML in this.container with new HTML
     * @param oldContainer the old container
     * @param label the label
     */
    abstract initHTML(oldContainer: JQuery, label: string);

    /**
     * To be called after replacing the HTML and setting this.container
     */
    initBehavior() {
        var oThis = this;

        this.container.click(function () {
            if(oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.SELECTED, Effect.EXECUTE, true));
                //oThis.container.trigger('mouseenter'); // Update feedforward
            }
        });

        this.container.hover(function() {
            if(oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.SELECTED, Effect.START_PREVIEW, true));
            }
        }, function () {
            if (oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.SELECTED, Effect.STOP_PREVIEW));
            }
        });
    }

    /**
     * Redirect event down to the responsible widget
     * @param event
     * @param windowState
     * @post the windowState will be updated
     */
    handleEvent(event, windowState) {
        if(event.identifier === this.identifier && event.action === Action.SELECTED) {
            windowState.getWidgetState(this.radioGroup.identifier).selectRadioButton(this.identifier);
        }
    }

    newState() {
        return new RadioButtonState();
    }

    setState(radioButtonState) {
        this.setSelected(radioButtonState.selected);
        this.setEnabled(radioButtonState.enabled);
    }

    previewState(radioButtonState, timeRatioLeft: number) {
        this.previewSelected(radioButtonState.selected, timeRatioLeft);
        this.previewEnabled(radioButtonState.enabled, timeRatioLeft);
    }

    removePreviewState() {
        this.removePreviewSelected();
        this.removePreviewEnabled();
    }

    getState() {
        var result = new RadioButtonState();

        result.enabled = this.isEnabled();
        result.selected = this.isSelected();

        return result;
    }
}